import { ScaffoldPage } from '@/components/layout/ScaffoldPage'
import { buildBreadcrumbs } from '@/config/routes'

export default function GovernanceDashboard() {
  return (
    <ScaffoldPage
      title="Governance Dashboard"
      description="Monitor storage consumption, growth trends, and data lifecycle status."
      breadcrumbs={buildBreadcrumbs('/settings/governance/dashboard')}
      plannedFeatures={[
        'Storage consumption breakdown by data type',
        'Growth trend charts and projections',
        'Data decay and archival status monitoring',
        'Cost allocation and optimization insights',
      ]}
      relatedPages={[
        { label: 'Storage Tiers', href: '/settings/governance/storage' },
        { label: 'Retention Policies', href: '/settings/governance/retention' },
      ]}
    />
  )
}
